import { z } from "zod";
const translationPath =
  "chatBot.page.automations.AutomationTasyOrientation.errors.";

const sendWhenSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "send_when" }
);

const typeTasyOrientationSchema = z.object(
  {
    id: z.string(),
    name: z.string().optional().nullable(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "type_tasy_orientation" }
);

const automationSchema = z.object({
  id: z.string(),
  name: z.string().optional().nullable(),
  code: z.string().optional().nullable(),
});

export const automationTasyOrientationSchema = z
  .object({
    id: z.string().optional(),
    sendWhen: sendWhenSchema,
    typeTasyOrientation: typeTasyOrientationSchema,
    automation: automationSchema.nullish(),
    enable: z.boolean(),
  })
  .superRefine((val, ctx) => {});

export type TAutomationTasyOrientationForm = z.infer<
  typeof automationTasyOrientationSchema
>;
